import { Component, OnDestroy, OnInit } from '@angular/core';
import * as moment from 'moment';
import { Moment, unix } from 'moment';
import { List } from 'linqts';
import { ApiService } from '../services/api.service';
import ScheduledChangeover from 'src/models/scheduled-changeover';
import { UserSessionService } from '../services/user-session.service';
import Line from 'src/models/line';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-schedule',
  templateUrl: './schedule.component.html',
  styleUrls: ['./schedule.component.scss']
})
export class ScheduleComponent implements OnInit, OnDestroy {
  isBusyLoading = false;
  private subscriptions: Array<Subscription> = [];
  agendaItems: Array<{ date: string, items: Array<ScheduledChangeover> }> = [];
  line: Line | null = null;

  constructor(
    private apiService: ApiService,
    private userSessionService: UserSessionService
  ) {
    this.subscriptions.push(
      this.userSessionService.activeLineIdChanged.subscribe(lineId => this.loadData())
    );
  }

  async ngOnInit(): Promise<void> {
    await this.loadData();
  }

  async ngOnDestroy(): Promise<void> {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  deleteChangeover = async (changeoverId: string) => {
    await this.apiService.deleteChangeover(changeoverId)
    await this.loadData();
  }

  private async loadData() {
    this.isBusyLoading = true;

    const [schedule, line] = await Promise.all([
      this.apiService.getScheduledChangeovers(this.userSessionService.activeLineId),
      this.line?.id === this.userSessionService.activeLineId
        ? Promise.resolve(this.line) 
        : this.apiService.getLine(this.userSessionService.activeLineId)
    ]);

    this.agendaItems = this.createAgendaItems(schedule);
    this.line = line;

    this.isBusyLoading = false;
  }

  createAgendaItems = (items: ScheduledChangeover[]) => {
    const groups = new List(items)
      .GroupBy(item => moment(item.time).startOf('d').unix(), item => item);

    const result = Object.entries(groups)
      .map(([unixEpoch, items]) => ({
        date: this.humanizeDate(unix(parseInt(unixEpoch))),
        items: items.map(item => ({ ...item, time: moment(item.time).format('HH:mm') } as ScheduledChangeover))
      }));
    return result;
  }

  humanizeDate = (date: Moment): string =>
    `${date.toDate().toDateString()}${date.isSame(moment(), 'd') ? ' — Today' : ''}`;
}
